import { ErrorMessage } from "@hookform/error-message";
import React, { useEffect } from "react";
import { useFieldArray, useFormContext } from "react-hook-form";
import { validations } from "../Validations/regexValidations";

function AuthorizedPeople() {
  const emptyFieldErrorMessage = "Campo obligatorio";
  const {
    register,
    control,
    formState: { errors },
  } = useFormContext();
  const { append, fields, prepend } = useFieldArray({
    control,
    name: "authorizedPeople",
  });

  useEffect(() => {
    !fields.length && prepend({});
  }, []);

  return (
    <React.Fragment>
      {fields.map((field, index) => {
        const baseName = `authorizedPeople[${index}]`;
        return (
				<div key={field.id} className="mt-6 create__requisitos">
					<h4 className="create__requisitos-title">
						Personas autorizadas para concertar, instruir o realizar las operaciones y
						transacciones con el intermediario de valores
					</h4>
					<div className="lg:items-end lg:flex lg:space-x-9">
						<div className="mb-4 group-form lg:w-1/2">
							<label className="global-label">Nombres</label>
							<input
								type="text"
								maxLength={40}
								className="global-input"
								placeholder="Nombres"
								{...register(`${baseName}.Names`, {
									required: { value: true, message: emptyFieldErrorMessage },
									pattern: validations.letrasYespacios,
								})}
							/>
							<div className="h-6 w-full">
								<ErrorMessage
									errors={errors}
									name={`${baseName}.Names`}
									render={({ message }) => <p className="text-red-600 ml-1">{message}</p>}
								/>
							</div>
						</div>
						<div className="mb-4 group-form lg:w-1/2">
							<label className="global-label">Apellidos</label>
							<input
								type="text"
								maxLength={40}
								className="global-input"
								placeholder="Apellidos"
								{...register(`${baseName}.LastNames`, {
									required: { value: true, message: emptyFieldErrorMessage },
									pattern: validations.letrasYespacios,
								})}
							/>
							<div className="h-6 w-full">
								<ErrorMessage
									errors={errors}
									name={`${baseName}.LastNames`}
									render={({ message }) => <p className="text-red-600 ml-1">{message}</p>}
								/>
							</div>
						</div>
					</div>
					<div className="lg:items-end lg:flex lg:space-x-9">
						<div className="mb-4 group-form lg:w-1/2">
							<label className="global-label">Nacionalidad</label>
							<input
								type="text"
								maxLength={20}
								className="global-input"
								placeholder="Nacionalidad"
								{...register(`${baseName}.Nationality`, {
									required: { value: true, message: emptyFieldErrorMessage },
									pattern: validations.letrasYespacios,
								})}
							/>
							<div className="h-6 w-full">
								<ErrorMessage
									errors={errors}
									name={`${baseName}.Nationality`}
									render={({ message }) => <p className="text-red-600 ml-1">{message}</p>}
								/>
							</div>
						</div>
						<div className="mb-4 group-form lg:w-1/2">
							<label className="global-label">Número de identificación</label>
							<input
								type="text"
								maxLength={11}
								className="global-input"
								placeholder="000-0000000-0"
								{...register(`${baseName}.IdNo`, {
									required: { value: true, message: emptyFieldErrorMessage },
									pattern: validations.letrasNumerosEspacios,
								})}
							/>
							<div className="h-6 w-full">
								<ErrorMessage
									errors={errors}
									name={`${baseName}.IdNo`}
									render={({ message }) => <p className="text-red-600 ml-1">{message}</p>}
								/>
							</div>
						</div>
					</div>
					<div className="lg:items-end lg:flex lg:space-x-9">
						<div className="mb-4 group-form lg:w-1/2">
							<label className="global-label">Posición en la empresa</label>
							<input
								type="text"
								maxLength={20}
								className="global-input"
								placeholder="Posición en la empresa"
								{...register(`${baseName}.CompanyPosition`, {
									required: { value: true, message: emptyFieldErrorMessage },
									pattern: validations.letrasYespacios,
								})}
							/>
							<div className="h-6 w-full">
								<ErrorMessage
									errors={errors}
									name={`${baseName}.CompanyPosition`}
									render={({ message }) => <p className="text-red-600 ml-1">{message}</p>}
								/>
							</div>
						</div>
						<div className="mb-4 group-form lg:w-1/2">
							<label className="global-label">Teléfono celular</label>
							<input
								type="text"
								maxLength={14}
								className="global-input"
								placeholder="(809) 000 - 0000"
								{...register(`${baseName}.PhoneNumber`, {
									required: { value: true, message: emptyFieldErrorMessage },
									pattern: validations.soloNumeros,
								})}
							/>
							<div className="h-6 w-full">
								<ErrorMessage
									errors={errors}
									name={`${baseName}.PhoneNumber`}
									render={({ message }) => <p className="text-red-600 ml-1">{message}</p>}
								/>
							</div>
						</div>
					</div>
					<div className="lg:items-end lg:flex lg:space-x-9">
						<div className="mb-4 group-form lg:w-1/2">
							<label className="global-label">Teléfono oficina</label>
							<input
								type="text"
								maxLength={14}
								className="global-input"
								placeholder="(809) 000 - 0000"
								{...register(`${baseName}.OfficeNumber`, {
									required: { value: true, message: emptyFieldErrorMessage },
									pattern: validations.soloNumeros,
								})}
							/>
							<div className="h-6 w-full">
								<ErrorMessage
									errors={errors}
									name={`${baseName}.OfficeNumber`}
									render={({ message }) => <p className="text-red-600 ml-1">{message}</p>}
								/>
							</div>
						</div>
						<div className="mb-4 group-form lg:w-1/2">
							<label className="global-label">Correo electrónico</label>
							<input
								type="text"
								className="global-input"
								placeholder="ejemplo@correo.com"
								{...register(`${baseName}.Email`, {
									required: { value: true, message: emptyFieldErrorMessage },
									pattern: validations.emails,
								})}
							/>
							<div className="h-6 w-full">
								<ErrorMessage
									errors={errors}
									name={`${baseName}.Email`}
									render={({ message }) => <p className="text-red-600 ml-1">{message}</p>}
								/>
							</div>
						</div>
					</div>
				</div>
			);
      })}
      <div className="mt-6 mb-6 text-center create__requisitos">
        <button
          type="button"
          onClick={() => {
            append({});
          }}
          className="mb-4"
        >
          <div className="mx-auto text-[#012169] opacity-50 text-[40px]">+</div>
          <span className="text-[#012169] opacity-50 font-bold mb-3">
            Agregar otra Persona autorizada para concertar, instruir o realizar
            las operaciones y transacciones con el intermediario de valores
          </span>
        </button>
      </div>
    </React.Fragment>
  );
}

export default AuthorizedPeople;
